import api from './api';

export const authService = {
  login: async (email, password) => {
    try {
      const response = await api.post('/api/dispatcher/auth/login', {
        login: email,
        password: password
      });

      if (response.data && response.data.token) {
        const { token, refreshToken, userId } = response.data;

        const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const userData = JSON.parse(decodeURIComponent(atob(payload)));
        userData.id = userId;

        authService.setUserData(token, userData, refreshToken);

        return { token, refreshToken, user: userData };
      }

      throw new Error('Токен не получен');
    } catch (error) {
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('refreshToken');
  },

  isAuthenticated: () => {
    const token = localStorage.getItem('token');
    return !!token;
  },

  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  getToken: () => {
    return localStorage.getItem('token');
  },

  setUserData: (token, user, refreshToken = null) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    if (refreshToken) {
      localStorage.setItem('refreshToken', refreshToken);
    }
  },

  getProfile: async () => {
    const response = await api.get('/api/dispatcher/profile');
    return response.data.body ?? response.data;
  },
};
